import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { BRAND } from '../../constants/branding';

export type LogoVariant = 'mark' | 'full' | 'wordmark';

interface AurieqLogoProps {
  variant?: LogoVariant;
  height?: number;
  to?: string | false;
}

const variantSrc: Record<LogoVariant, string> = {
  mark: BRAND.assets.iconMark,
  full: BRAND.assets.logoFull,
  wordmark: BRAND.assets.wordmark,
};

const defaultHeight: Record<LogoVariant, number> = {
  mark: 36,
  full: 56,
  wordmark: 40,
};

export const AurieqLogo: React.FC<AurieqLogoProps> = ({
  variant = 'mark',
  height,
  to = '/',
}) => {
  const h = height ?? defaultHeight[variant];

  const img = (
    <Box
      component="img"
      src={variantSrc[variant]}
      alt={BRAND.name}
      sx={{
        height: h,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );

  if (to) {
    return (
      <Box component={RouterLink} to={to} sx={{ textDecoration: 'none', display: 'inline-flex' }}>
        {img}
      </Box>
    );
  }

  return img;
};

export default AurieqLogo;
